const INFO_TEXT = {
  DID_YOU_FIND_WHAT_YOU_ARE_LOOKING_FOR: 'Aradığınız ürünü bulabildiniz mi?',
  THANK_YOU_FOR_YOUR_FEEDBACK: 'Geri bildiriminiz için teşekkür ederiz.',
  TYPE_YOUR_FEEDBACK_BELOW: 'Görüş ve önerilerinizi aşağıdaki forma yazın.',
};

const FEEDBACK_TYPES = {
  EVET: 'Evet',
  HAYIR: 'Hayır',
  YES: 'Yes',
  NO: 'No',
  CANCEL: 'Cancel',
  SEND: 'Gönder',
};

const FEEDBACK_VALIDATIONS = {
  MAX_DESCRIPTION_LENGTH: 2000,
  MIN_DESCRIPTION_LENGTH: 3,
  MIN_CHARACTER_LIMIT_ERROR: 'Lütfen en az 3 karakter giriniz.',
  MAX_CHARACTER_LIMIT_ERROR: 'Yorum en fazla 2000 karakter içerebilir.',
  INVALID_DESCRIPTION_REGEX: '([^\\W_\\d]([^\\W_\\d]|[-\'\\d](?=[^\\W_\\d]))*[^\\W_\\d])',
  INVALID_DESCRIPTION_ERROR: 'Lütfen daha açıklayıcı yorum giriniz.',
  DISALLOWED_CHARACTERS_REGEX: /([^a-zA-Z0-9 .,?!ığüşöçİĞÜŞÖÇ])/g,
  DISALLOWED_CHARACTERS_REPLACEMENT: '\\$1',
};

export {
  INFO_TEXT,
  FEEDBACK_TYPES,
  FEEDBACK_VALIDATIONS,
}